export default __webpack_public_path__ + "static/char-v-61-zh-Hant-0364606a643138c26f518a0cea124504.mp4";